import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const ErrorIcon = styled(Box)({
  fontSize: '16px',
  color: 'var(--error)',
  marginRight: '6.4px',
});

ErrorIcon.defaultProps = {
  component: 'i',
  className: 'bx bxs-error-circle',
};

export default ErrorIcon;
